import { josa } from 'josa'

export default {
  name: 'ko',
  messages: {
    required: (attr) =>
      attr === '약관'
        ? `${attr} 동의가 필요합니다.`
        : josa(`${attr}#{는} 필수 입력사항입니다.`),
    email: '이메일 형식이 올바르지 않습니다.',
    min: (attr, { length }) =>
      josa(`${attr}#{는} ${length}자리 이상이어야 합니다.`),
    confirmed: '비밀번호 값이 일치하지 않습니다.',
    url: (attr) => `${attr}이 올바르지 않습니다.`,
    excluded: () => '중복되는 값이 존재합니다.',
    not_comma: () => '콤마(,)는 허용되지 않습니다.',
    date_format: (attr, value) =>
      josa(`${attr}#{는} ${value[0]} 형식이어야 합니다.`),
    digits: (attr, { length }) => `${attr}은 ${length}자리 숫자이어야 합니다.`,
    max: (attr, { length }) =>
      josa(`${attr}#{는} 최대 ${length}자를 넘을 수 없습니다.`),
    page_num: () => '올바른 쪽수를 입력해주세요. (1~99999 사이 정수)',
    asc: (attr) => josa(`${attr}#{는} 오름차순이어야 합니다.`)
  },
  names: {
    oauth: '로그인 제공업체',
    id: '아이디',
    email: '이메일',
    subject: '제목',
    password: '비밀번호',
    repeated: '비밀번호 확인',
    policies: '약관',
    reviewUrl: '서평 URL',
    date: '날짜',
    title: '제목',
    authors: '지은이',
    translators: '옮긴이',
    publisher: '출판사',
    newTag: '태그',
    tag: '태그',
    text: '내용',
    pageNum: '쪽수'
  }
}
